<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" style="padding-left:50px;"><div class="section level2" id="the-north-sea"><div class="section level4" id="part-1-taybridge-road"><div class="section level5" id="aberfeldy-perthshire-scotland">
<div>
<p style="width:550px; padding-top:20px; padding-top:20px;  font-size:10pt;font-family:calibri;">Since then, I have more often climbed the ladder leading from the first floor to the loft. There, a skylight opens to the view in the opposite direction. At the window, I look down the valley of the Tay, seeing the Highlands descend towards Scotland’s eastern seaboard. On a dreamy summer day, when the sun on the slates of the roof warms the loft, a light mist often softens the view. In my mind, I see through the haze the North Sea and, afar, the line of a shore. It shows few features other than the church towers of numerous villages, many towns and a few not very large cities – all set in a flat landscape. In one of these cities I was born, on the twenty fourth day of October 1930.</p>
</div>
</div>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0017.vue?b624c2aa